import { SxProps, Theme } from "@mui/material";

/** Figma Order Details: 16px checkbox, 8px gap to label. */
export const redesignOrderDetailsCheckboxControlSx: SxProps<Theme> = {
  p: 0,
  width: 16,
  height: 16,
  "& .MuiSvgIcon-root": {
    fontSize: 16,
  },
};

export const redesignOrderDetailsFormControlLabelSx: SxProps<Theme> = {
  m: 0,
  gap: 1,
  alignItems: "center",
  "& .MuiFormControlLabel-label": {
    typography: "body2",
  },
};
